import React from 'react'
import Search from './Search'
import MaxNodes from './MaxNodes'
import Credentials from './Credentials'
import About from './About'

const Modals = () => {
  return (
    <>
      <Search />
      <MaxNodes />
      <Credentials />
      <About />
    </>
  )
}

export default Modals
